export default function getAverageOfArray(arr) {
  const arrSum = arr.reduce((sum, value) => sum + value, 0)
  return Math.round(arrSum / arr.length)
}
